import React from 'react';
import { useSelector } from 'react-redux';

export const useAccount = () => {
  return useSelector(({ account }) => account);
};
